import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { MtgLogo } from "@/components/MtgLogo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset — please sign in");
      navigate("/login");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-8">
      <div className="w-full max-w-sm">
        <MtgLogo withText className="h-6 w-6" />
        <form onSubmit={submit} className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <h1 className="font-heading text-xl font-bold text-slate-900">Set a new password</h1>
          <p className="mt-1 text-sm text-slate-500">Choose a new password for your account.</p>
          <div className="mt-5">
            <Label htmlFor="pw">New password</Label>
            <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} data-testid="reset-password-input" className="mt-1.5" />
          </div>
          {error && <div className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>}
          {!token && <div className="mt-3 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-700">Missing reset token in link.</div>}
          <Button type="submit" disabled={loading || !token} data-testid="reset-submit-button" className="mt-5 w-full bg-teal-600 hover:bg-teal-700">
            {loading ? "Saving..." : "Reset password"}
          </Button>
          <Link to="/login" className="mt-5 inline-flex items-center gap-1.5 text-sm text-teal-700 hover:underline">
            <ArrowLeft className="h-4 w-4" /> Back to sign in
          </Link>
        </form>
      </div>
    </div>
  );
}
